<template>
  <PopDialog2
    title="새 공지"
    :visible="props.visible"
    :cancelCallback="onCancelClick"
  >
    <div class="notice-modal-content">
      <!-- 제목 영역 -->
      <div class="notice-modal-header">
        <div class="notice-icon-wrapper">
          <i class="fa-regular fa-envelope notice-icon"></i>
        </div>
        <h3 class="notice-modal-title">{{ props.data.title }}</h3>
        <div class="notice-date-info" v-if="props.data.startDate && props.data.endDate">
          <i class="fa-regular fa-calendar me-1"></i>
          <span>{{ formatDate(props.data.startDate) }} ~ {{ formatDate(props.data.endDate) }}</span>
        </div>
      </div>

      <!-- 내용 영역 -->
      <div class="notice-modal-body">
        <div class="html-wrapper" v-html="props.data.content" />
      </div>

      <!-- 하단 체크박스 -->
      <div class="notice-modal-footer">
        <div class="notice-checkbox-wrapper">
          <label class="notice-checkbox-label" for="noticeNeverSee">
            <input
              class="notice-checkbox"            
              type="checkbox"
              id="noticeNeverSee"
              @change="onNeverSeeChange"
            />
            <span class="checkbox-custom"></span>
            <span class="checkbox-text">다시 보지 않기</span>
          </label>
        </div>
      </div>
    </div>
  </PopDialog2>
</template>

<script setup>
import { defineProps, onMounted } from 'vue';
import moment from 'moment';
import PopDialog2 from '@/common/components/popup/PopDialog2.vue';
import useMobile from '@/common/hooks/useMobile';

const { setLocalStorage } = useMobile();
const props = defineProps([
  'visible',
  'cancelCallback',
  'data',
]);

const formatDate = (date) => {
  return moment(date).format("YYYY-MM-DD");
};

onMounted(() => {
  const elem = document.querySelector(".html-wrapper");
  if (elem) {
    const images = elem.querySelectorAll("img");
    if (images.length > 0) {
      images.forEach((image) => {
        image.style.width = "100%";
        image.style.borderRadius = "8px";
        image.style.marginTop = "0.5rem";
        image.style.marginBottom = "0.5rem";
      });
    }
  }
});

const onNeverSeeChange = async (e) => {
  try {
    await setLocalStorage(`notice${props.data._id}`, true);
  } catch(e) {
    console.log(e);
  } finally {
    if (props.cancelCallback) {
      props.cancelCallback();
    }
  }
};

const onCancelClick = () => {
  if (props.cancelCallback) {
    props.cancelCallback();
  }
};
</script>

<style scoped>
.notice-modal-content {
  padding: 0.5rem;
}

.notice-modal-header {
  text-align: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e9ecef;
}

.notice-icon-wrapper {
  margin-bottom: 0.75rem;
}

.notice-icon {
  font-size: 2.5rem;
  color: #0d6efd;
  background: linear-gradient(135deg, #e7f1ff 0%, #cfe2ff 100%);
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(13, 110, 253, 0.2);
}

.notice-modal-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #212529;
  margin: 0.75rem 0 0.5rem 0;
  line-height: 1.4;
}

.notice-date-info {
  font-size: 0.875rem;
  color: #6c757d;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  margin-top: 0.5rem;
}

.notice-date-info i {
  color: #0d6efd;
}

.notice-modal-body {
  min-height: 100px;
  max-height: 400px;
  overflow-y: auto;
  padding: 1rem 0;
  margin-bottom: 1rem;
}

.html-wrapper {
  font-size: 0.95rem;
  line-height: 1.6;
  color: #495057;
}

.html-wrapper :deep(p) {
  margin-bottom: 0.75rem;
}

.html-wrapper :deep(ul),
.html-wrapper :deep(ol) {
  margin-bottom: 0.75rem;
  padding-left: 1.5rem;
}

.html-wrapper :deep(img) {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 0.5rem 0;
}

.notice-modal-footer {
  padding-top: 1rem;
  border-top: 1px solid #e9ecef;
}

.notice-checkbox-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.notice-checkbox {
  display: none;
}

.notice-checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  gap: 0.5rem;
}

.checkbox-custom {
  width: 20px;
  height: 20px;
  border: 2px solid #dee2e6;
  border-radius: 4px;
  display: inline-block;
  position: relative;
  transition: all 0.2s ease;
  background-color: #ffffff;
}

.notice-checkbox:checked ~ .checkbox-custom {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.notice-checkbox:checked ~ .checkbox-custom::after {
  content: '';
  position: absolute;
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.checkbox-text {
  font-size: 0.875rem;
  color: #495057;
  font-weight: 500;
  transition: color 0.2s ease;
}

.notice-checkbox:checked ~ .checkbox-text {
  color: #0d6efd;
}

@media (max-width: 768px) {
  .notice-icon {
    font-size: 2rem;
    width: 3.5rem;
    height: 3.5rem;
  }
  
  .notice-modal-title {
    font-size: 1.1rem;
  }
  
  .notice-modal-body {
    max-height: 300px;
  }
}
</style>